import styled, { css } from 'styled-components';
import TimePicker, { type TimePickerFieldProps } from '../../components/TimePickerField';

export const TimePickerContainer = styled.div<{ $readOnly?: boolean }>`
    & .ant-form-item-label {
        padding-bottom: 4px;
    }
    & .ant-form-item-label > label {
        font-weight: 400;
    }

    & .ant-picker {
        height: 48px;
        padding: 8px;
        border: 1px solid rgb(98, 102, 105);
        border-radius: 0;

        outline: transparent solid 1px;
        outline-offset: 2px;

        & input {
            font-size: var(--input-font-size, 1rem);
        }

        &.ant-picker-disabled {
            ${props =>
                props.$readOnly &&
                css`
                    background-color: #fff;

                    & .ant-picker-input > input[disabled] {
                        color: ${props => props.theme.antd['text-color']};
                        cursor: text;
                    }
                `}

            background-color: transparent;
            border-color: rgb(150, 152, 154);
            color: rgb(150, 152, 154);

            & .ant-picker-suffix {
                display: none;
            }
        }

        &:focus,
        &.ant-picker-focused {
            outline-color: rgb(98, 102, 105);
        }
    }

    & .ant-picker-status-error.ant-picker,
    & .ant-picker-status-error.ant-picker:not([disabled]):hover {
        border: 2px solid rgb(224, 0, 0);
    }

    & .ant-picker-status-error.ant-picker-focused {
        outline: rgb(224, 0, 0) solid 1px;
    }

    & .ant-picker-disabled {
        color: rgb(150, 152, 154);
        border-color: rgb(150, 152, 154);
    }
`;

type TimePickerProps = TimePickerFieldProps & { readOnly?: boolean };

const TimePickerField = ({ readOnly, ...props }: TimePickerProps) => (
    <TimePickerContainer $readOnly>
        <TimePicker {...props} />
    </TimePickerContainer>
);

export default TimePickerField;
